import { Breakpoint } from '@altibox/design-system-component-lib';
import React, { FC } from 'react';

import { Video } from 'src/api/@generated/backend';

import { i18n } from 'src/i18n';
import { VideoThumbnail } from 'src/components/video-thumbnail';

import { StyledContainer, StyledLabel, StyledVideoContainer } from './videos.styled';

interface Props {
  videos: Video[];
}

export const Videos: FC<Props> = (props) => {
  const { videos } = props;

  if (!videos.length) {
    return null;
  }

  return (
    <StyledContainer>
      <StyledLabel variant="paragraph2" component="p" maxBreakpoint={Breakpoint.TABLET}>
        {i18n.page.productDetails.video.title}
      </StyledLabel>
      <StyledVideoContainer>
        {videos.map((video, index) => (
          <VideoThumbnail key={index} description={video.description} thumbnail={video.thumbnailUrl} url={video.url} />
        ))}
      </StyledVideoContainer>
    </StyledContainer>
  );
};
